import * as React from "react";

const SvgMinusRules = (props) => (
  <svg
    width={30}
    height={30}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#minus-rules_svg__a)">
      <path
        d="M15 30C6.716 30 0 23.284 0 15 0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15Zm7.5-16.5h-15v3h15v-3Z"
        fill="#242424"
      />
    </g>
    <defs>
      <clipPath id="minus-rules_svg__a">
        <path fill="#fff" d="M0 0h30v30H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMinusRules;
